export const LangOptions = [
  { value: "en", label: "English" },
  { value: "fr", label: "Français" },
];

export const ProvinceOptions = [
  { value: "tor", label: "Toronto/GTA" },
  { value: "mtl", label: "Montréal Area" },
  { value: "van", label: "Metro Vancouver" },
];

export const FRProvinceOptions = [
  { value: "tor", label: "Région de Toronto" },
  { value: "mtl", label: "Région de Montréal" },
  { value: "van", label: "Région de Vancouver" },
];

export const ReasonOptions = [
  { value: "order", label: "I want to order Beanfield" },
  { value: "question", label: "I have questions about Beanfield services" },
  { value: "general_inquiry", label: "General inquiry" },
]

export const FRReasonOptions = [
  { value: "order", label: "Je souhaite commander Beanfield" },
  { value: "question", label: "J'ai des questions sur les services Beanfield" },
  { value: "general_inquiry", label: "Enquête générale" },
]

export const ProductOptions = [
  { value: "internet", label: "Internet" },
  { value: "tv", label: "TV" },
  { value: "home_phone", label: "Home Phone" },
]

export const FRProductOptions = [
  { value: "internet", label: "Internet" },
  { value: "tv", label: "Télévision" },
  { value: "home_phone", label: "Téléphonie Résidentielle" },
]
